const ProductInfo = (props: { className?: string }) => (
  <svg width={40} height={40} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" className={props.className}>
    <path d="M32 32H8V8H32V32ZM18 17V29H22V17H18ZM18 11V15H22V11H18Z" fill="#E25317" />
  </svg>
);
export default ProductInfo;
